import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="main-footer" className="bg-dark py-16 border-t border-dark/10">
      <div className="container mx-auto px-6 md:px-12 max-w-[1600px]">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex gap-8">
            <button
              onClick={() => scrollToSection('projects')}
              className="nav-link text-xs uppercase tracking-widest text-cream hover:text-yellow transition-colors"
            >
              Films
            </button>
            <button
              onClick={() => scrollToSection('photography')}
              className="nav-link text-xs uppercase tracking-widest text-cream hover:text-yellow transition-colors"
            >
              Photography
            </button>
            <button
              onClick={() => scrollToSection('workshops')}
              className="nav-link text-xs uppercase tracking-widest text-cream hover:text-yellow transition-colors"
            >
              Workshops
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="nav-link text-xs uppercase tracking-widest text-cream hover:text-yellow transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="nav-link text-xs uppercase tracking-widest text-cream hover:text-yellow transition-colors"
            >
              Contact
            </button>
          </div>

          <div className="flex gap-6">
            <a
              href="https://www.instagram.com/dyduch/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-link"
              className="text-cream hover:text-yellow transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={24} />
            </a>
            <a
              href="https://www.linkedin.com/in/amy-dyduch-b6b4b643/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="linkedin-link"
              className="text-cream hover:text-yellow transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={24} />
            </a>
          </div>

          <p className="text-xs text-cream/50">
            © {new Date().getFullYear()} Amy Dyduch. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
